import { useMediaQuery } from './use-media-query';

export type HeroViewportTier = 'desktop' | 'compact' | 'mobile';

const MOBILE_VIEWPORT_QUERY = '(max-width: 600px)';
const COMPACT_VIEWPORT_QUERY = '(max-width: 1024px)';

export function useViewportTier(): HeroViewportTier {
	const isMobile = useMediaQuery(MOBILE_VIEWPORT_QUERY);
	const isCompact = useMediaQuery(COMPACT_VIEWPORT_QUERY);

	if (isMobile) return 'mobile';
	return isCompact ? 'compact' : 'desktop';
}
